// extracted by mini-css-extract-plugin
export default {"item":"ItemPage_item__2veJd"};